// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Breadcrumb.css */

.breadcrumb {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 12px;
  font-size: 15px;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-item a {
  text-decoration: none;
  color: blue;
}

.breadcrumb-item span.separator {
  margin: 0 5px;
  color: grey;
}

.breadcrumb-item span {
  color: grey;
}

  `, "",{"version":3,"sources":["webpack://./src/components/common/breadcrumb/Breadcrumb.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* src/components/Breadcrumb.css */\n\n.breadcrumb {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-left: 12px;\n  font-size: 15px;\n}\n\n.breadcrumb-item {\n  display: flex;\n  align-items: center;\n}\n\n.breadcrumb-item a {\n  text-decoration: none;\n  color: blue;\n}\n\n.breadcrumb-item span.separator {\n  margin: 0 5px;\n  color: grey;\n}\n\n.breadcrumb-item span {\n  color: grey;\n}\n\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
